import type { IRidCodeLeerplusSaveState } from './rid-game.utils';

/**
 * The uid of the homework assignment an activity plays out, via the stop links that map each assignment's config to
 * the activity started for it. Undefined for an activity that isn't homework, or homework without a backend uid.
 */
export function findHomeworkAssignmentUid(
  state: Pick<IRidCodeLeerplusSaveState, 'homework' | 'homeworkLinks'>,
  activityUid: string,
): string | undefined {
  for (const link of state.homeworkLinks.stops) {
    const configUid = Object.keys(link.assignmentActivityUids).find((uid) => link.assignmentActivityUids[uid] === activityUid);
    if (configUid === undefined) continue;

    const stop = state.homework.stops.find((s) => s.id === link.homeworkStopId);
    return stop?.assignments.find((a) => a.config.uid === configUid)?.uid;
  }

  return undefined;
}
